var render = function render(){var _vm=this,_c=_vm._self._c;return _c('mars-view',{staticClass:"experthome-popup-bottom"},[_c('mars-image',{staticClass:"experthome-popup-bottom-pic",attrs:{"src":"https://youjia.cdn.bcebos.com/image/lvlin-logo.png","alt":""}}),_c('mars-view',{staticClass:"experthome-popup-bottom-line"}),_c('mars-view',{staticClass:"experthome-popup-bottom-text"},[_vm._v("百度旗下专业法律服务平台")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }